<template>
    <v-col class="pt-0 stepContainer" cols="12" sm="12">
        <!-- >>> Title -->
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <h2 v-if="leg === 'firstLeg'" class="mb-2">
                    First Leg
                </h2>
                <h2 v-if="leg === 'secondLeg'" class="mb-2">
                    Second Leg
                </h2>
            </v-col>
        </v-row>
        <!-- <<< Title -->


        <!-- >>> Row 1 -->
        <!-- #227  Disable A/C Field in Update Mode LINE 31 -->
        <!--  || editorMode === 'update' -->
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-select
                            v-model="data[leg].input_AircraftConfig"
                            :items="get_AircraftConfigs"
                            :rules ="[
                                showDeleteCheckbox ? true : rules.req(data[leg].input_AircraftConfig),
                            ]"
                            item-value="id"
                            item-text="code"
                            prepend-icon="mdi-airplane"
                            clearable
                            disabled
                            @change="onChange_input_AircraftConfig"
                            @focus="onFocus_setFocusedInput('input_AircraftConfig')">
                            <template v-slot:label>
                                <p>
                                Aircraft Config <span style="color: red; font-size: 1.4rem;">*</span>
                                </p>
                            </template>
                        </v-select>
                    </v-col>
                    <!-- TODO:  -->
                    <v-col cols="12" sm="6">
                        <v-select
                            v-model="data[leg].input_MainServiceType"
                            :items="items_MainServiceTypes"
                            label="Main Service Type"
                            item-value="value"
                            item-text="text"
                            prepend-icon="mdi-dots-square"
                            @focus="onFocus_setFocusedInput('input_MainServiceType')" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <!-- <<< Row 1 -->


        <!-- >>> Row 2 -->
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <v-row>
                    <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                        <v-text-field
                            v-model="data[leg].input_CodeShare"
                            name="input_CodeShare"
                            maxlength="7"
                            :rules ="[
                                rules.max(7, data[leg].input_CodeShare),
                            ]"
                            counter
                            clearable
                            prepend-icon="mdi-barcode"
                            label="Code Share"
                            :disabled="input_Delete_CodeShare"
                            @focus="onFocus_setFocusedInput('input_CodeShare')" />
                    </v-col>

                    <v-col v-if="showDeleteCheckbox" cols="12" sm="1">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <div multiple v-on="on">
                                <v-checkbox
                                    v-model="input_Delete_CodeShare"
                                    off-icon="mdi-trash-can-outline"
                                    on-icon="mdi-trash-can-outline"
                                    @change="v => onChange_deleteForAll(leg, v, 'CODE_SHARE', 'input_CodeShare')" />
                                </div>
                            </template>
                            <span>Delete for all</span>
                        </v-tooltip>
                    </v-col>

                    <v-col cols="12" :sm="showDeleteCheckbox ? '5' : '6'">
                        <v-select
                            v-model="data[leg].input_Range"
                            :items="items_Range"
                            item-value="value"
                            item-text="text"
                            prepend-icon="mdi-text-short"
                            label="Range"
                            :disabled="input_Delete_Range"
                            clearable
                            @focus="onFocus_setFocusedInput('input_Range')" />
                    </v-col>

                    <v-col v-if="showDeleteCheckbox" cols="12" sm="1">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <div multiple v-on="on">
                                    <v-checkbox
                                        v-model="input_Delete_Range"
                                        off-icon="mdi-trash-can-outline"
                                        on-icon="mdi-trash-can-outline"
                                        @change="v => onChange_deleteForAll(leg, v, 'RANGE', 'input_Range')" />
                                    </div>
                            </template>
                            <span>Delete for all</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <!-- <<< Row 2 -->

         <!-- >>> Row 3 -->
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <v-row>
                    <v-col cols="12" :sm="showDeleteCheckbox ? '11' : '12'">
                         <v-textarea
                            v-model="data[leg].input_PermissionNumber"
                            name="input_PermissionNumber"
                            maxlength="160"
                            :rules ="[
                                rules.max(160, data[leg].input_PermissionNumber),
                            ]"
                            counter
                            auto-grow
                            clearable
                            prepend-icon="mdi-check-decagram"
                            :disabled="input_Delete_PermissonNumber"
                            label="Permission Number"
                            @focus="onFocus_setFocusedInput('input_PermissionNumber')" />
                    </v-col>

                    <v-col v-if="showDeleteCheckbox" cols="12" sm="1">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <div multiple v-on="on">
                                    <v-checkbox
                                        v-model="input_Delete_PermissonNumber"
                                        off-icon="mdi-trash-can-outline"
                                        on-icon="mdi-trash-can-outline"
                                        @change="v => onChange_deleteForAll(leg, v, 'PERMISSION_NUMBER', 'input_PermissionNumber')" />
                                    </div>
                            </template>
                            <span>Delete for all</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <!-- <<< Row 3 -->

        <!-- >>> Row 4 -->
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <v-row>
                    <v-col cols="12" :sm="showDeleteCheckbox ? '11' : '12'">
                        <v-select
                            v-model="data[leg].input_ServiceFlags"
                            :items="items_ServiceFlags"
                            item-text="text"
                            item-value="value"
                            name="input_ServiceFlags"
                            multiple
                            chips
                            prepend-icon="mdi-list-status"
                            label="Service Flags"
                            :disabled="input_Delete_ServiceFlags"
                            @focus="onFocus_setFocusedInput('input_ServiceFlags')">
                            <template slot="selection" slot-scope="item">
                                <v-chip>
                                    <v-icon style="margin-right: 8px">
                                        {{ item.item.icon }}
                                    </v-icon>
                                    <div>
                                        {{ item.item.text }}
                                    </div>
                                </v-chip>
                            </template>
                        </v-select>
                    </v-col>

                    <v-col v-if="showDeleteCheckbox" cols="12" sm="1">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <div multiple v-on="on">
                                <v-checkbox
                                    v-model="input_Delete_ServiceFlags"
                                    off-icon="mdi-trash-can-outline"
                                    on-icon="mdi-trash-can-outline"
                                    @change="v => onChange_deleteForAll(leg, v, 'SERVICE_FLAGS', 'input_ServiceFlags')" />
                                </div>
                            </template>
                            <span>Delete for all</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <!-- <<< Row 4 -->

        <!-- >>> Row 5 -->
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <v-row>
                    <!-- >>> FlightComment -->
                    <v-col cols="12" :sm="showDeleteCheckbox ? '11' : '12'">
                         <v-textarea
                            v-model="data[leg].input_FlightComment"
                            name="input_FlightComment"
                            maxlength="400"
                            :rules ="[
                                rules.max(400, data[leg].input_FlightComment),
                            ]"
                            auto-grow
                            counter
                            clearable
                            prepend-icon="mdi-comment"
                            label="Comment"
                            value=""
                            :disabled="input_Delete_FlightComment"
                            @focus="onFocus_setFocusedInput('input_FlightComment')" />
                    </v-col>
                    <v-col v-if="showDeleteCheckbox" cols="12" sm="1">
                        <v-checkbox
                            v-model="input_Delete_FlightComment"
                            off-icon="mdi-trash-can-outline"
                            on-icon="mdi-trash-can-outline"
                            @change="v => onChange_deleteForAll(leg, v, 'FLIGHTCOMMENT', 'input_FlightComment')" />
                    </v-col>
                    <!-- <<< FlightComment -->
                </v-row>
            </v-col>
        </v-row>
        <!-- <<< Row 5 -->
</v-col>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { eventBus } from '../../../../../../../main';


    export default {
        name: 'SdrStep1Flightconfig',

        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // 'update', 'create'
            editorFlightLegMode: String, // 'single', 'rotation'
            data: Object, // entire 'crud' Object
            leg: String, // "firstLeg", "secondLeg"
            rules: Object, // entire 'rules' Object
            showDeleteCheckbox: Boolean,
            onFocus_setFocusedInput: Function

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                input_Delete_CodeShare: false,
                input_Delete_Range: false,
                input_Delete_PermissonNumber: false,
                input_Delete_ServiceFlags: false,
                input_Delete_FlightComment: false,
                // >>> -----
                items_MainServiceTypes: [
                    {
                        text: 'C - Charter Flight',
                        value: 'C'
                    },
                    {
                        text: 'J - Scheduled Flight',
                        value: 'J'
                    }
                ],
                items_Range: [
                    {
                        text: 'Short',
                        value: 'SHORT'
                    },
                    {
                        text: 'Long',
                        value: 'LONG'
                    }
                ],
                items_ServiceFlags: [
                    {
                        text: 'Baggage Service',
                        value: 'BAGGAGE',
                        icon: 'mdi-bag-suitcase'
                    },
                    {
                        text: 'Flight Reservation',
                        value: 'FLIGHT',
                        icon: 'mdi-airplane'
                    },
                    {
                        text: 'Flex Option',
                        value: 'INSURANCE',
                        icon: 'mdi-file'
                    },
                    {
                        text: 'Meal Service',
                        value: 'MEAL',
                        icon: 'mdi-silverware-fork-knife'
                    },
                    {
                        text: 'Medical Service',
                        value: 'MEDICAL',
                        icon: 'mdi-pill'
                    },
                    {
                        text: 'Seat Reservation',
                        value: 'SEAT',
                        icon: 'mdi-seat-passenger'
                    },
                    {
                        text: 'Standard Service',
                        value: 'STANDARD',
                        icon: 'mdi-bicycle'
                    },
                    {
                        text: 'Train Reservation',
                        value: 'TRAIN',
                        icon: 'mdi-train'
                    }

                ]
            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([

                'get_AircraftConfigs'

            ])

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/Step1FlightConfig.vue >>> created');
            eventBus.$on('flightswasupdated', this.onEmit_FlightWasUpdated);

		}, // eo function created()
		/* <<< ****************************************************************/



        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/Step1FlightConfig.vue >>> destroyed');
            eventBus.$off('flightswasupdated', this.onEmit_FlightWasUpdated);

		}, // eo function destroyed()
        /* <<< *************************************************************** /



        /* >>> ***************************************************************** / /* Methods */
        methods: {


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
           /*******************************************************************
            * onEmit_FlightWasUpdated()
            *
            * Desc: Reset Values after Flight Update
            * Note:
            *
            *
            */
            onEmit_FlightWasUpdated: function() {

                const me = this;


                me.input_Delete_CodeShare = false;
                me.input_Delete_Range = false;
                me.input_Delete_PermissonNumber = false;
                me.input_Delete_ServiceFlags = false;
                me.input_Delete_FlightComment = false;

            }, // eo function onEmit_FlightWasUpdated()

            /*******************************************************************
            * onChange_input_AircraftConfig
            *
            * Desc:
            * Note:
            *
            */
            onChange_input_AircraftConfig: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/Step1FlightsConfig.vue >>> onChange_input_AircraftConfig');
                if (this.leg === 'firstLeg') {
                    this.data.secondLeg.input_AircraftConfig = this.data.firstLeg.input_AircraftConfig;
                }

                if (this.leg === 'secondLeg') {
                    this.data.firstLeg.input_AircraftConfig = this.data.secondLeg.input_AircraftConfig;
                }

            }, // eo function onChange_input_AircraftConfig()


            /*******************************************************************
            * onChange_deleteForAll
            *
            * Desc:
            * Note:
            *
            */
            onChange_deleteForAll: function(leg, value, type, inputName) {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/Step1FlightsConfig.vue >>> onChange_deleteForAll');
                me.data[me.leg][inputName] = '';
                eventBus.$emit('markToDeleteBus', { leg: leg, type: type, value: value });

            } // eo function onChange_deleteForAll()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
